import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Typography } from "@mui/material";
import { PRIMARY_TEXT_COLOR } from "../../../constants/Colors";
import LoadingButton from "../../../general_components/LoadingButton";
import CustomSelectField from "./customSelectField";

export default function MoveProjectModal({
  open,categoryName,
    loading, handleClose, categoryList, setCurrentCategory, projectId,
    currentCategory, previousCategory, handleMoveProject
}) {
     const onSubmit = async (e) => {
      e.preventDefault();
      const data = { currentCategory: currentCategory, previousCategory: previousCategory, projectId: projectId };
      handleMoveProject(data);
      handleClose();
  };
  
  return (
    <>
      <Dialog open={open} onClose={handleClose} maxWidth="sm">
        <DialogTitle>
          <Typography
            variant={"body1"}
            style={{ color: PRIMARY_TEXT_COLOR, fontWeight: "600" }}
          >
            {`Move ${
              categoryName?.charAt(0).toUpperCase() +
              categoryName?.slice(1).toLowerCase()
            } Project To`}
          </Typography>
        </DialogTitle>
        <DialogContent style={{ width: 350, paddingTop: 15 }}>
          <form onSubmit={onSubmit}>
            <CustomSelectField
              autoFocus={true}
              required
              disabled={loading}
              select={true}
              data={categoryList}
              labelName={"Select Category"}
              style={{ marginBottom: 25 }}
              setCurrentCategory={setCurrentCategory}
              previousCategory={previousCategory}
            />
            <LoadingButton type={"submit"} loading={loading} text={"Move"} />
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
}
